import { useState } from 'react';
import { cn } from '@/lib/utils';
import ActionButton from '@/components/buttons/ActionButton.tsx';

/** Powyżej tej długości komentarz startuje zwinięty do trzech linii. */
const COLLAPSE_FROM_LENGTH = 240;

interface RejectionCommentCellProps
  extends React.HTMLAttributes<HTMLDivElement> {
  comment: string;
}

/**
 * Komentarz zapisującego przy odrzuconej paczce — osobna linia na całą szerokość
 * wiersza, bo w wąskiej kolumnie „Paczka” długi tekst robił się wysoką wstęgą.
 */
const RejectionCommentCell = ({
  comment,
  className,
  ...props
}: RejectionCommentCellProps) => {
  const collapsible =
    comment.length > COLLAPSE_FROM_LENGTH || comment.split('\n').length > 3;
  const [expanded, setExpanded] = useState(false);

  return (
    <div role="cell" className={cn('max-w-prose', className)} {...props}>
      <div
        className={cn(
          'wrap-anywhere whitespace-pre-line text-[13px] text-neutral-500',
          collapsible && !expanded && 'line-clamp-3',
        )}
      >
        <span className="font-semibold text-neutral-600">
          Komentarz zapisującego:
        </span>{' '}
        {comment}
      </div>
      {collapsible && (
        <ActionButton
          tone="ghost"
          size="xs"
          className="-ml-2 mt-1"
          aria-expanded={expanded}
          onClick={() => setExpanded((value) => !value)}
        >
          {expanded ? 'Zwiń' : 'Pokaż całość'}
        </ActionButton>
      )}
    </div>
  );
};

export default RejectionCommentCell;
